import Confirm from '../components/confirm.vue';
import events from '@utils/context-vue';

export default {
	install(Vue) {
		const root = new Vue({
			data: {},
			render: (createElement) => createElement(Confirm)
		});
		const elem = document.createElement('div');
		root.$mount(document.body.appendChild(elem));
		const metodo = (params, loading) => {
			if (typeof params === 'string') {
				params = {
					id: '',
					message: '',
					titleOk: '',
					titleCancelar: '',
					callbackOk: null,
					callbackCancelar: null
				};
			}

			events.$emit('setLoading', loading);

			if (typeof params === 'object' && params !== null) {
				events.$emit('setData', params);
			}
		};
		Vue.prototype.$confirm = metodo;
	}
};
